import { RadioGroup, SelectBox, Template } from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { axiosGet } from "../../apis/useAxios";
import { DataGridSkeletonPageSimple } from "../skeleton/GridSkeleton";

export const shuttleTypeLst = [
  { id: 0, name: "All" },
  { id: 1, name: "Hotel Shuttle" },
  { id: 2, name: "Local Vender" },
  { id: 3, name: "Not Available" },
];

export default function AirportHotelLocationTransportMatrixComponent() {
  const [state, setState] = useState({
    isTransportMatrixApiLoading: false,
    isAirportDropdownApiLoading: false,
    transportMatrixGridLst: [],
    transportMatrixGridDataSource: [],
    filterAirportDropdownDataSource: [],
    filterAirportCode: "",
    shuttleTypeId: 0,
  });
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML = `Transport Matrix`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          isAirportDropdownApiLoading: true,
        }));
        await getFilterAirportDropdown();
        setState((prev) => ({
          ...prev,
          isAirportDropdownApiLoading: false,
        }));
      }, 0);
      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          isTransportMatrixApiLoading: true,
        }));
        await getTransportMatrixGridDataSource(state.filterAirportCode);
        setState((prev) => ({
          ...prev,
          isTransportMatrixApiLoading: false,
        }));
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };

  const getFilterAirportDropdown = async () => {
    try {
      const response = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      setState((prev) => ({
        ...prev,
        filterAirportDropdownDataSource: response?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getTransportMatrixGridDataSource = async (airportCode) => {
    try {
      const response = await axiosGet(
        `HotelTransferContract/airport-hotel-location-transport-matrix`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: airportCode,
        },
      );
      let transportMatrixGridLst = response.payload ?? [];
      setState((prev) => ({
        ...prev,
        transportMatrixGridLst: transportMatrixGridLst,
      }));
      await filterTransMatrixDataGridShuttleTypeWise(
        state.shuttleTypeId,
        transportMatrixGridLst,
      );
    } catch (error) {
      console.log(error);
    }
  };

  const filterTransMatrixDataGridShuttleTypeWise = async (
    shuttleTypeId,
    transportMatrixGridLst,
  ) => {
    try {
      let transportMatrixGridDataSource = [
        ...new Set(
          transportMatrixGridLst?.filter(
            (f) =>
              shuttleTypeId === 0 ||
              (shuttleTypeId === 1 &&
                f.isShuttleAvailable === true &&
                f.isHotelShuttle === true) ||
              (shuttleTypeId === 2 &&
                f.isShuttleAvailable === true &&
                f.isHotelShuttle === false) ||
              (shuttleTypeId === 3 && f.isShuttleAvailable === false),
          ),
        ),
      ];
      setState((prev) => ({
        ...prev,
        transportMatrixGridDataSource: transportMatrixGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <style>{`
        /* ── Airport Hotel Transport Matrix — theme matching sidebar #fff0e6 ── */
        .ca-grid-wrap .dx-header-row td {
          background-color: #fff0e6 !important;
          color: #000000 !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .ca-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .ca-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .ca-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          padding: 0.35rem 0.6rem !important;
        }
        .ca-grid-wrap .dx-datagrid-header-panel {
          border-bottom: 1px solid #e8d5c4 !important;
          padding-bottom: 10px !important;
          margin-bottom: 4px !important;
        }
      `}</style>
      <div className="card ca-grid-wrap">
        <div className="card-body">
          {state.isTransportMatrixApiLoading && <DataGridSkeletonPageSimple />}
          {!state.isTransportMatrixApiLoading && (
            <>
              <DataGrid
                ref={refDataGrid}
                dataSource={state.transportMatrixGridDataSource}
                showBorders={true}
                columnAutoWidth={true}
                allowColumnResizing={true}
                showRowLines={true}
                showColumnLines={true}
                onCellPrepared={(e) => {
                  if (e.rowType === "header") {
                    e.cellElement.style.backgroundColor = "#fff0e6";
                    e.cellElement.style.color = "#000000";
                  }
                }}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift(
                    {
                      location: "before",
                      template: "toolbarFilterAirportDropdown",
                    },
                    {
                      location: "before",
                      template: "toolbarShuttleTypeDrodown",
                    },
                    {
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          try {
                            refDataGrid.current.instance.beginCustomLoading();
                            e.component.option(
                              "icon",
                              "fas fa-spinner fa-spin",
                            );
                            await new Promise((resolve) =>
                              setTimeout(resolve, 500),
                            );
                            await getTransportMatrixGridDataSource();
                            refDataGrid.current.instance.endCustomLoading();
                            e.component.option("icon", "refresh");
                          } catch (error) {
                            console.log(error);
                          }
                        },
                      },
                    },
                  );
                }}
                onRowPrepared={(e) => {
                  if (e.rowType === "header") {
                    e.rowElement.style.backgroundColor = "#f0f2f5";
                  }
                  if (e.rowType === "data") {
                    if (!e.data?.isShuttleAvailable) {
                      e.rowElement.style.backgroundColor = "#ffcccb";
                      e.rowElement.style.foregroundColor = "#ffffff";
                    } else {
                      if (e.data?.isHotelShuttle) {
                        e.rowElement.style.backgroundColor = "#f5e6a2";
                      } else {
                        e.rowElement.style.backgroundColor = "#ccffcc";
                      }
                    }
                  }
                }}
              >
                <Column
                  dataField="airlineCode"
                  caption="Airline"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="airportCode"
                  caption="Station"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                {/* <Column
                  dataField="airportName"
                  caption="Airport"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                /> */}
                <Column
                  dataField="fromLocation"
                  caption="From Location"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="toLocation"
                  caption="To Location"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="crewTypeName"
                  caption="Crew Type"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="terminal"
                  caption="Terminal"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                {/* <Column
                  dataField="forAllTerminal"
                  caption="For All Terminal"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                /> */}
                <Column
                  dataField="shuttleProvider"
                  caption="Shuttle Provider"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="isShuttleAvailable"
                  caption="Shuttle Available"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="isHotelShuttle"
                  caption="Hotel Shuttle"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Column
                  dataField="transferType"
                  caption="Transfer Type"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                />
                <Template
                  name="toolbarFilterAirportDropdown"
                  render={() => {
                    return (
                      <>
                        <SelectBox
                          dataSource={state.filterAirportDropdownDataSource}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select airport"
                          defaultValue={state.filterAirportCode}
                          displayExpr="airportName"
                          valueExpr="airportCode"
                          showClearButton={true}
                          searchEnabled={true}
                          width={300}
                          onValueChanged={async (e) => {
                            try {
                              refDataGrid.current.instance.beginCustomLoading();
                              let filterAirportCode = e.value ?? "";
                              setState((prev) => ({
                                ...prev,
                                filterAirportCode: filterAirportCode,
                              }));
                              await new Promise((resolve) =>
                                setTimeout(resolve, 500),
                              );
                              await getTransportMatrixGridDataSource(
                                filterAirportCode,
                              );
                              refDataGrid.current.instance.endCustomLoading();
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        />
                        {state.isAirportDropdownApiLoading && (
                          <i
                            className="fas fa-spinner fa-spin text-green"
                            style={{
                              float: "right",
                              marginTop: "-22px",
                              marginRight: "12px",
                            }}
                          />
                        )}
                      </>
                    );
                  }}
                />
                <Template
                  name="toolbarShuttleTypeDrodown"
                  render={() => {
                    return (
                      <>
                        <div className="dx-widget dx-collection">
                          <span style={{ fontSize: "1em", fontWeight: "bold" }}>
                            Shuttle Type
                          </span>
                          <div className="dx-field">
                            <RadioGroup
                              id="radio-group-with-selection"
                              items={shuttleTypeLst}
                              value={state.shuttleTypeId}
                              valueExpr="id"
                              displayExpr="name"
                              layout="horizontal"
                              onValueChanged={(e) => {
                                try {
                                  let shuttleTypeId = e.value ?? 1;
                                  setState((prev) => ({
                                    ...prev,
                                    shuttleTypeId: e.value,
                                  }));
                                  filterTransMatrixDataGridShuttleTypeWise(
                                    shuttleTypeId,
                                    state.transportMatrixGridLst,
                                  );
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </>
                    );
                  }}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="AirportHotelLocationTransportMatrix"
                />
              </DataGrid>
            </>
          )}
        </div>
      </div>
    </>
  );
}
